import React from 'react'
import Navbar from './catalogNav/CatalogNav'
// import { AddNotify } from './AddNotify'
export const Notification = () => {

    return (
        <div>
            <Navbar />
        </div>
    )
}
